import { render, staticRenderFns } from "./promt.vue?vue&type=template&id=512bd3dc"
import script from "./promt.vue?vue&type=script&lang=js"
export * from "./promt.vue?vue&type=script&lang=js"
import style0 from "./promt.vue?vue&type=style&index=0&id=512bd3dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports